import ClearIcon from '@mui/icons-material/Clear';
import { IconButton, InputAdornment, TextField } from '@mui/material';

function JSearchInput(props) {
  const { value, onChange, placeholder } = props;

  return (
    <TextField
      placeholder={placeholder || 'Search here...'}
      variant="outlined"
      size="small"
      fullWidth
      InputProps={{
        endAdornment: value && (
          <InputAdornment position="end">
            <IconButton onClick={() => onChange('')} size="small">
              <ClearIcon fontSize="inherit" />
            </IconButton>
          </InputAdornment>
        ),
      }}
      onChange={(evt) => onChange(evt.target.value)}
      value={value}
    />
  );
}

export default JSearchInput;
